export function splitModelIdentifier(input: string): { model: string; body: string } {
  let body = '';
  let model = '';

  if (input === 'DISABLED') return { model, body };

  if (input === 'MARCO_POLO') return { model: 'MARCO_POLO', body: '' };

  const doubleBodyTypes = ['LONG_SEDAN', 'PANEL_VAN', 'PEOPLE_CARRIER', 'SHOOTING_BRAKE'];
  for (const bodyType of doubleBodyTypes) {
    if (input.endsWith(bodyType)) {
      const parts = input.split('_');
      model = parts.slice(0, parts.length - bodyType.split('_').length).join('_');
      body = bodyType;
      return { model, body };
    }
  }

  if (!input.includes('_')) {
    body = input;
    return { model, body };
  }

  const parts = input.split('_');
  model = `${parts[0]}_${parts[1]}`;
  body = parts.slice(2).join('_');
  return { model, body };
}

export function removeClassSuffixForOneSearch(value: string | undefined): string {
  return value?.split('_')[0] ?? '';
}
